import * as React from "react";
import { Checkbox } from "../../Checkbox";
var TabbedMultiSelectCheckbox = function (_a) {
    var item = _a.item, label = _a.label, rightContent = _a.rightContent, included = _a.included, onItemInclusionChanged = _a.onItemInclusionChanged;
    var onChange = React.useCallback(function (e) {
        onItemInclusionChanged(item, e.target.checked);
    }, [item, onItemInclusionChanged]);
    return (React.createElement("div", { className: "bn-tabbedmultiselect-item" },
        React.createElement(Checkbox, { className: "bn-tabbedmultiselect-checkbox", checked: included, onChange: onChange }, label),
        rightContent && (React.createElement("div", { className: "bn-tabbedmultiselect-item-contentright" }, rightContent))));
};
export default TabbedMultiSelectCheckbox;
//# sourceMappingURL=TabbedMultiListCheckbox.js.map